import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonLoading, IonPage, IonTitle, IonToolbar, useIonAlert } from '@ionic/react';
import { arrowBack, cardOutline, cashOutline, qrCodeOutline, walletOutline } from 'ionicons/icons';
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { mesaGerarCupom, projetoGerarCupomPdf, requestService } from '../../../../../Utils/Services';
import './CaixaDetalhes.css';

function iconePagamento(tipo: string) {
  const t = (tipo || '').toLowerCase();
  if (t.includes('credito') || t.includes('crédito') || t.includes('debito') || t.includes('débito') || t.includes('cartao') || t.includes('cartão')) return cardOutline;
  if (t.includes('pix')) return qrCodeOutline;
  if (t.includes('dinheiro')) return cashOutline;
  return walletOutline;
}

const CaixaDetalhes: React.FC = () => {
  const location = useLocation<any>();
  const history = useHistory();
  const [presentAlert] = useIonAlert();
  const [showLoading, setShowLoading] = useState(false);

  const comanda = location.state?.comanda;

  const anotacoesFiltradas = comanda?.anotacoes
    ?.filter((a: any) => !Array.isArray(a))
    ?.sort((a: any, b: any) => (a.data < b.data ? 1 : -1)) || [];

  function dataFormatada(dateStr: string | undefined) {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleString('pt-BR');
  }

  function gerarCupomTxt() {
    if (!comanda?.pk) return;
    setShowLoading(true);
    const url = mesaGerarCupom.url.replace('{id}', comanda.pk.replaceAll(/#/g, '%23'));
    requestService(url, { method: mesaGerarCupom.method }, history,
      (data: any) => {
        setShowLoading(false);
        presentAlert({
          backdropDismiss: false, header: 'Cupom',
          message: '<strong>Cupom</strong> gerado com sucesso.',
          buttons: [{ text: 'Cancelar', role: 'cancel' }, { text: 'Visualizar', handler: () => { window.open(data, '_blank'); } }]
        });
      },
      (err: any) => { setShowLoading(false); presentAlert({ header: 'Erro', message: err?.message || 'Não foi possível gerar o cupom.', buttons: ['OK'] }); }
    );
  }

  function gerarCupomPdf() {
    if (!comanda?.pk) return;
    setShowLoading(true);
    const url = projetoGerarCupomPdf.url.replace('{id}', comanda.pk.replaceAll(/#/g, '%23'));
    requestService(url, { method: projetoGerarCupomPdf.method }, history,
      (data: any) => {
        setShowLoading(false);
        presentAlert({
          backdropDismiss: false, header: 'Cupom PDF',
          message: '<strong>Cupom PDF</strong> gerado com sucesso.',
          buttons: [{ text: 'Cancelar', role: 'cancel' }, { text: 'Visualizar', handler: () => { window.open(data, '_blank'); } }]
        });
      },
      (err: any) => { setShowLoading(false); presentAlert({ header: 'Erro', message: err?.message || 'Não foi possível gerar o cupom PDF.', buttons: ['OK'] }); }
    );
  }

  if (!comanda) {
    return (
      <IonPage>
        <IonHeader><IonToolbar color="primary"><IonButtons slot="start"><IonButton onClick={() => history.goBack()}><IonIcon icon={arrowBack} /></IonButton></IonButtons><IonTitle>Detalhes</IonTitle></IonToolbar></IonHeader>
        <IonContent className="ion-padding"><p>Nenhuma informação disponível.</p></IonContent>
      </IonPage>
    );
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}><IonIcon icon={arrowBack} /></IonButton>
          </IonButtons>
          <IonTitle>Detalhes {comanda.clienteNome || 'Balcão'}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonLoading isOpen={showLoading} message="Aguarde..." />

        {/* Info abertura/encerramento */}
        <div className="detDates">
          <div className="detDateItem">
            <span className="detDateLabel">Abertura</span>
            <span className="detDateValue">{dataFormatada(comanda.dataCadastro)}</span>
          </div>
          {comanda.dataAlteracao && (
            <div className="detDateItem">
              <span className="detDateLabel">Encerramento</span>
              <span className="detDateValue">{dataFormatada(comanda.dataAlteracao)}</span>
            </div>
          )}
        </div>

        {/* Produtos */}
        {comanda.produtos?.length > 0 && (
          <div className="detSection">
            <p className="detSectionTitle">Produtos</p>
            {comanda.produtos.map((prod: any, pi: number) => {
              const nomeProduto = prod.descricao?.[0]?.descricao || '-';
              const complementos = prod.descricao?.slice(1)?.filter((c: any) => c.descricao && c.descricao !== '') || [];
              return (
                <div key={'caixaprod' + pi} className="detProdRow">
                  <div className="detProdInfo">
                    <span className="detProdNome"><b>{prod.quantidade}x</b> {nomeProduto}</span>
                    {complementos.map((c: any, ci: number) => (
                      <span key={'comp' + pi + ci} className="detCompItem">
                        + {c.descricao}{c.valor && c.valor !== '0,00' ? ` (R$ ${c.valor})` : ''}
                      </span>
                    ))}
                    {prod.anotacao && <span className="detProdObs">{prod.anotacao}</span>}
                  </div>
                  <div className="detProdPreco">
                    <span className="detProdUnit">unt. R$ {prod.valor}</span>
                    <span className="detProdSubtotal">R$ {prod.subtotal}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Resumo Financeiro */}
        <div className="detSection">
          <p className="detSectionTitle">Resumo</p>
          {comanda.valorTotalProdutos && (
            <div className="detResumoRow">
              <span>Subtotal produtos</span>
              <span>R$ {comanda.valorTotalProdutos}</span>
            </div>
          )}
          {comanda.taxaServico && (
            <div className="detResumoRow">
              <span>Taxa de serviço ({comanda.taxaServico}%)</span>
              <span>R$ {comanda.valorTotalProdutos
                ? (parseFloat(comanda.valorTotalProdutos.replace(/\./g, '').replace(',', '.')) * parseFloat(comanda.taxaServico) / 100).toFixed(2).replace('.', ',')
                : '0,00'}</span>
            </div>
          )}
          {comanda.taxaEntrega && (
            <div className="detResumoRow">
              <span>Taxa de entrega</span>
              <span>R$ {comanda.taxaEntrega}</span>
            </div>
          )}
          {comanda.desconto && (
            <div className="detResumoRow detDesconto">
              <span>Desconto</span>
              <span>- R$ {comanda.desconto}</span>
            </div>
          )}
          <div className="detTotalRow">
            <span>TOTAL</span>
            <span>R$ {comanda.valorTotal || '0,00'}</span>
          </div>
        </div>

        {/* Formas de Pagamento */}
        {comanda.formaPagamento?.length > 0 && (
          <div className="detSection">
            <p className="detSectionTitle">Pagamento</p>
            {comanda.formaPagamento.map((pag: any, fi: number) => (
              <div key={'caixapag' + fi} className="detPagRow">
                <IonIcon icon={iconePagamento(pag.tipo || pag.pagamento)} className="detPagIcon" />
                <span className="detPagTipo">{pag.tipo || pag.pagamento}</span>
                <span className="detPagValor">R$ {pag.valor}</span>
              </div>
            ))}
            {comanda.troco && comanda.troco !== '0,00' && (
              <div className="detResumoRow detTroco">
                <span>Troco</span>
                <span>R$ {comanda.troco}</span>
              </div>
            )}
          </div>
        )}

        {/* Anotações */}
        {anotacoesFiltradas.length > 0 && (
          <div className="detSection">
            <p className="detSectionTitle">Anotações</p>
            {anotacoesFiltradas.map((anotacao: any) => (
              <div key={'caixaanot' + anotacao.id} className="detAnotRow">
                <span className="detAnotMeta">
                  {new Date(anotacao.data).toLocaleDateString('pt-BR')} {new Date(anotacao.data).toLocaleTimeString('pt-BR')}
                  {anotacao.pessoa && <b> · {anotacao.pessoa}</b>}
                </span>
                <span className="detAnotTexto">{anotacao.anotacao}</span>
              </div>
            ))}
          </div>
        )}

        <div style={{ height: 16 }} />
      </IonContent>

      {/* <IonFooter>
        <IonToolbar>
          <div className="detFooterBtns">
            <IonButton expand="block" onClick={gerarCupomTxt}>
              <IonIcon slot="start" icon={printOutline} />
              Cupom TXT
            </IonButton>
            <IonButton expand="block" fill="outline" onClick={gerarCupomPdf}>
              <IonIcon slot="start" icon={documentOutline} />
              Cupom PDF
            </IonButton>
          </div>
        </IonToolbar>
      </IonFooter> */}
    </IonPage>
  );
};

export default CaixaDetalhes;
